import request from '@/axios'

export function blogCreate (customer_id, query) {
  return request({
    url: `/blog/create/${customer_id}`,
    method: 'POST',
    data: query
  })
} 

export function blogEdit (customer_id, blog_id, query) {
  return request({
    url: `/blog/edit/${customer_id}/${blog_id}`,
    method: 'POST',
    data: query
  })
}

export function blogDelete (customer_id, blog_id) {
  return request({
    url: `blog/delete/${customer_id}/${blog_id}`,
    method: 'GET'
  })
}


export function fetchBlog (platform_customer_id, blog_id) {
  return request({
    url: `/blog/show/${blog_id}/${platform_customer_id}`,
    method: 'GET'
  })
}

export function blogList (platform_customer_id, query) {
  return request({
    url: `/blog/list/${platform_customer_id}?page=${query.page}&search=${query.search}`,
    method: 'GET'
  })
}


export function createComment (customer_id, blog_id, query) {
  return request({
    url: `/blog/comment/create/${blog_id}/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function editComment (customer_id, blog_id, comment_id, query) {
  return request({
    url: `/blog/comment/edit/${blog_id}/${comment_id}/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function deleteComment (customer_id, blog_id, comment_id, portal_type) {
  return request({
    url: `blog/comment/delete/${blog_id}/${comment_id}/${portal_type}/${customer_id}`,
    method: 'GET'
  })
}

export function showComment (customer_id, blog_id, comment_id) {
  return request({
    url: `/blog/comment/show/${blog_id}/${comment_id}/${customer_id}`,
    method: 'GET'
  })
}


export function emoticonsList () {
  return request({
    url: 'blog/emoticons/list',
    method: 'GET'
  })
}

export function emoticonsDelete (customer_id, blog_id, portal_type) {
  return request({
    url: `blog/emoticons/delete/${blog_id}/${portal_type}/${customer_id}`,
    method: 'GET'
  })
}

export function emoticonsUpdate (customer_id, blog_id, query) {
  return request({
    url: `blog/emoticons/update/${blog_id}/${customer_id}`,
    method: 'POST',
    data: query
  })
}


export function commentsEmoticonsUpdate (customer_id, blog_id, comment_id, query) {
  return request({
    url: `blog/comment/emoticons/update/${blog_id}/${comment_id}/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function commentsEmoticonsDelete (customer_id, blog_id, comment_id, portal_type) {
  return request({
    url: `blog/comment/emoticons/delete/${blog_id}/${comment_id}/${portal_type}/${customer_id}`,
    method: 'GET'
  })
}


export function fetchUserClint (customer_id, user_type, query,payload=null) {
  return request({
    url: `/users/fetch_user_list/${user_type}/${customer_id}?page=${query.page}`,
    method: 'POST',
    data: payload
  })
}


export function blogShare (customer_id, blog_id, query) {
  return request({
    url: `blog/share/${customer_id}/${blog_id}`,
    method: 'POST',
    data: query
  })
}

